import type { ProductData } from '@sofa-platform/types'

/**
 *Returns the current cover name for a product.
 */
export function parseProductCoverName(productData: ProductData, separator = ' ') {
  const designPart = productData.content.validDesignPart
  if (!designPart) return ''

  const coverParts = designPart
    .filter((part) => part.typeName === 'COVER')
    .sort((a, b) => Number(a.position) - Number(b.position))

  const lowestPositionColorPart = designPart
    .filter((part) => part.typeName === 'COLOU')
    .sort((a, b) => Number(a.position) - Number(b.position))
    .at(0)

  const result = [...coverParts, lowestPositionColorPart].filter(Boolean)

  return result.map((part) => part.text).join(separator)
}
